import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import MPage from "../templates/mpage";
import Cargando from "../components/cargando";
import ErrorMensaje from "../components/errormensaje";
import useTituloPagina from "../../utils/useTituloPagina";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faEnvelope,
  faPhone,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

import useObtenerMunicipio from "../../utils/useObtenerMunicipio";

const Contacto = (props) => {
  const [municipio, error] = useObtenerMunicipio(props.match.params.munUrl);
  useTituloPagina(municipio ? `Contacto — ${municipio.nombre}` : null);

  if (error === true)
    return (
      <ErrorMensaje
        titulo="No encontramos este municipio"
        mensaje="Puede que el enlace esté mal escrito o que el municipio no esté disponible."
      />
    );
  if (municipio === undefined) return <Cargando />;

  const { nombre, nombreUrl, email, tel, web } = municipio;
  return (
    <MPage municipio={municipio}>
      <h1 className="centrado font-weight-light mt-4 mb-2 h2">Contactanos</h1>
      <div className="centrado">
        <div className="card m-3">
          <div className="card-header font-weight-bold">{nombre}</div>
          <div className="card-body">
            <p>
              <FontAwesomeIcon
                icon={faEnvelope}
                color="#0a4797"
                className="fa-2x mx-3"
              />
              {/*mailto/tel: en el celular abren directamente el mail o el
                 teléfono. El sr-only nombra el dato para lectores de pantalla,
                 porque el ícono por sí solo no lo dice.*/}
              <span className="sr-only">Correo electrónico: </span>
              <a className="ppr-a" href={`mailto:${email}`}>
                {email}
              </a>
            </p>
            <p>
              <FontAwesomeIcon
                icon={faPhone}
                color="#0a4797"
                className="fa-2x mx-3"
              />
              <span className="sr-only">Teléfono: </span>
              <a className="ppr-a" href={`tel:${String(tel).replace(/[^\d+]/g, "")}`}>
                {tel}
              </a>
            </p>
            <p>
              <FontAwesomeIcon
                icon={faGlobe}
                color="#0a4797"
                className="fa-2x mx-3"
              />
              <span className="sr-only">Sitio web: </span>
              <a
                className="ppr-a"
                href={web.startsWith("http") ? web : `//${web}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {web}
              </a>
            </p>
          </div>
        </div>

        <div className="card m-3">
          <div className="card-header font-weight-bold">
            Programa Raíz de Apoyo a la Gestión Local SEU UNC
          </div>
          <div className="card-body">
            <p>
              <FontAwesomeIcon
                icon={faEnvelope}
                color="#0a4797"
                className="fa-2x mx-3"
              />
              <span className="sr-only">Correo electrónico: </span>
              <a className="ppr-a" href="mailto:gestionlocal@extension.unc.edu.ar">
                gestionlocal@extension.unc.edu.ar
              </a>
            </p>
          </div>
        </div>

        <div className="text-center mb-3">
          <Link
            to={"/municipio/" + nombreUrl}
            className="btn ppr-btn-verde font-weight-bold m-2"
          >
            Volver
          </Link>
        </div>
      </div>
    </MPage>
  );
};

export default withRouter(Contacto);
